import React, { useEffect, useState } from "react";
import Header from '../../components/Header/index'
import FooterTwo from "../../components/Footer/FooterTwo";
import Breadcrumb from '../../components/Breadcrumb/index';
import StoryService from "../../services/story.service";
import { Link } from "react-router-dom";

const Story=()=>{
    const [storyList,setStoryList]=useState([]);
    const [extra,setExtra]=useState({});
    const [query,setQuery]=useState({});

    // const stories=[
    //     {poster:"./img/story/poster-1.png"},
    //     {poster:"./img/story/poster-2.png"},
    //     {poster:"./img/story/poster-1.png"},

    //     {poster:"./img/story/poster-1.png"},
    //     {poster:"./img/story/poster-2.png"},
    //     {poster:"./img/story/poster-1.png"},

    //     {poster:"./img/story/poster-1.png"},
    //     {poster:"./img/story/poster-2.png"},
    //     {poster:"./img/story/poster-1.png"},
    // ];

    const handlePagination=(page,type)=>{
        let query={};
        switch(type){
            case "prev":query.page=extra.page -1;break;
            case "next":query.page=extra.page +1;break;
            default:query.page=page;
        }
        setQuery(query);
    }

    useEffect(()=>{
        StoryService.list(query)
        .then(res=>{setStoryList(res?.data);setExtra(res?.extra)})
        .catch(err=>console.log(err));
    },[query]);

    return (
        <>
        <Header/>
        <Breadcrumb pageTitle={"Success Story"}/>
        <section className="py-4 mb-5">
            <h2 className="display-4 fw-bold my-5 text-center text-black">Success <strong style={{color:"#FE7743"}} className=" fw-semibold">Story</strong></h2>
            <div className="container">
                <div className="row row-cols-sm-2 row-cols-lg-3 g-4">
                    {
                        storyList?.map((item,idx)=>(

                            <div style={{transition:".3s"}} key={idx} className="position-relative awards_card">
                                <Link style={{width:"100%",height:"100%",display:"inline-block"}} to={`/success-story-detail/${item?.slug}`}>
                                <img src={item?.thumbnailImgUrl} style={{width:"100%",height:"100%"}} className="shadow border-3 border-white w-full h-full object-fit-cover"/>

                                </Link>
                            </div>

                            // <div key={idx} className="col-12 position-relative">
                            // <video className="shadow border-3 border-white p-2 img-fluid" width={380} height={300} poster={item?.poster}>
                            //     <source src="/"/>
                            // </video>
                            // <button className="border-0 outline-none bg-transparent position-absolute top-50 start-50 translate-middle"><img src="./img/story/play.svg" width={60} height={60}/></button>
                            // </div>

                        ))
                    }
                </div>

                <ul className="back-pagination pt---20">
                <li className="back-next">
                    <button onClick={()=>handlePagination(undefined,"prev")}>
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 12H19M5 12L11 6M5 12L11 18" stroke="#5B5F64" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg></button></li>
                    <li><button style={{background: "#3270FC", color: "#ffffff"}} onClick={()=>handlePagination(Number(extra.page))} >{extra.page}</button></li>
                    <li><button onClick={()=>handlePagination(Number(extra.page +1))} >{extra.page +1}</button></li>
                    <li className="back-next"><button onClick={()=>handlePagination(undefined,"next")}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></button></li>
                </ul>

            </div>
        </section>
        <FooterTwo/>
        </>


    )
};

export default Story;